/* eslint-disable */
import r1 from './r1.js'

var i = function () {
  function i(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, i),
      this.views = [],
      this.timer = -1,
      this.debounceTime = e
  }
  return r1(i, null, [{
    key: "start",
    value: function () {
      var e = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0]
        , t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 400;
      i.instance || (i.instance = new i(t)),
        window.addEventListener("resize", e ? i.debounceResize : i.resize),
        i.resize()
    }
  }, {
    key: "bind",
    value: function (e, t) {
      i.instance.views.push({
        id: e,
        fn: t
      })
    }
  }, {
    key: "unbind",
    value: function (e) {
      for (var t = i.instance, n = 0; n < t.views.length; n++)
        if (t.views[n].id === e) {
          t.views.splice(n, 1);
          break
        }
    }
  }, {
    key: "debounceResize",
    value: function () {
      window.clearTimeout(i.instance.timer),
        i.instance.timer = window.setTimeout(i.resize, i.instance.debounceTime)
    }
  }, {
    key: "resize",
    value: function () {
      var e = i.instance.views;
      window.w = document.documentElement.clientWidth,
        window.h = document.documentElement.clientHeight;
      for (var t = 0; t < e.length; t++)
        e[t].fn(window.w, window.h)
    }
  }]),
    i
}();
var t = { default: i }

export default t
